module.exports = __webpack_public_path__ + "static/media/186.38cad21b.wav";